import { render, staticRenderFns } from "./news_topic.vue?vue&type=template&id=09d1c9ee&scoped=true&"
import script from "./news_topic.vue?vue&type=script&lang=js&"
export * from "./news_topic.vue?vue&type=script&lang=js&"
import style0 from "./news_topic.vue?vue&type=style&index=0&id=09d1c9ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1c9ee",
  null
  
)

export default component.exports